// JS Dependencies
import * as bootstrap from 'bootstrap';
import 'jquery';
import 'jquery-migrate/dist/jquery-migrate.min.js'
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jrespond';
import 'toastr';
import 'jquery-slimscroll';
import 'screenfull';
import 'jquery-bar-rating';
import 'node-waves';

// CSS Dependencies
import 'bootstrap/dist/css/bootstrap.min.css';
import 'toastr/build/toastr.min.css';
import 'animate.css/animate.min.css';
import 'node-waves/dist/waves.min.css'

// Expose Bootstrap globally so non-module scripts (e.g. kendo-editor.js)
// can access bootstrap.Modal, bootstrap.Tooltip, etc.
window.bootstrap = bootstrap;

//console.log('The \'site\' bundle has been loaded!');